import { Controller } from "@hotwired/stimulus"

// Holds the trial slide's floaters back until the screenshot behind them has
// actually decoded and the document is complete. Without this the rise plays
// while the 1.3MB capture is still loading, so by the time the slide is on
// screen the cards have already landed and the entrance is missed.
//
// The class only arms the animation — .slide--trial.active is what starts it,
// so the entrance still replays every time the slide is entered.
export default class extends Controller {
  static targets = ["shot"]
  static classes = ["ready"]

  connect() {
    this.check = this.check.bind(this)

    // Both theme variants of the capture are in the DOM, so wait on all of them.
    this.shotTargets.forEach((shot) => {
      if (shot.complete) return
      shot.addEventListener("load", this.check, { once: true })
      // A broken image must not strand the floaters invisible forever.
      shot.addEventListener("error", this.check, { once: true })
    })

    if (document.readyState === "complete") {
      this.check()
    } else {
      window.addEventListener("load", this.check, { once: true })
    }
  }

  disconnect() {
    window.removeEventListener("load", this.check)
  }

  check() {
    const shotsReady = this.shotTargets.every((shot) => shot.complete)
    if (!shotsReady || document.readyState !== "complete") return
    this.element.classList.add(this.hasReadyClass ? this.readyClass : "is-ready")
  }
}
